import { Link } from "react-router-dom";
import { LuArrowRight } from "react-icons/lu";
import SeoHead from "../../components/SeoHead";
import { pageMeta } from "../../data/pageMeta";
import { articles } from "./articles";

export default function BlogIndex() {
  return (
    <>
      <SeoHead
        {...pageMeta["/blog"]}
        ogUrl="https://edi-converter.de/blog"
      />

      <section className="page-hero page-hero-center">
        <div className="container">
          <h1 className="h1">EDIFACT Blog</h1>
        </div>
      </section>

      <section className="section-sm">
        <div className="container">
          <div className="grid grid-3">
            {articles.map(post => (
              <Link key={post.slug} to={`/blog/${post.slug}`} className="card card-link">
                {post.image && (
                  <div className="card-link-overflow">
                    <img src={post.image} alt={post.title} className="blog-card-img" loading="lazy" />
                  </div>
                )}
                <div className="blog-card-body">
                  <div className="blog-card-title">{post.title}</div>
                  <p className="blog-card-excerpt">{post.excerpt}</p>
                  <span className="blog-card-more">
                    Weiterlesen <LuArrowRight className="card-link-arrow" size={15} aria-hidden="true" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
